import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  mode: 'each',
  inputArray: '',
  expression: 'return $json',
  options: {
    keepOnError: true,
    ignoreNull: false,
  },
};

export default defaults;
